// Task Board — kanban for project tasks
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
const tasks = (projectId?: number) => fetch(`/api/v1/project.task${projectId?`?projectId=${projectId}`:""}`,{headers:{"X-Dev-Auth":"dev","X-Tenant-ID":"1"}}).then(r=>r.json()).then((r:any)=>r.ok?r.data:[]);
const projects = () => fetch("/api/v1/project.project",{headers:{"X-Dev-Auth":"dev","X-Tenant-ID":"1"}}).then(r=>r.json()).then((r:any)=>r.ok?r.data:[]);
const move = (id: number, stage: string) => fetch(`/api/v1/project.task/${id}/move`,{method:"POST",headers:{"X-Dev-Auth":"dev","X-Tenant-ID":"1","Content-Type":"application/json"},body:JSON.stringify({stage})});
const create = (d:any) => fetch("/api/v1/project.task",{method:"POST",headers:{"X-Dev-Auth":"dev","X-Tenant-ID":"1","Content-Type":"application/json"},body:JSON.stringify(d)}).then(r=>r.json());

const STAGES = ["todo","in_progress","review","done"];
const STAGE_LABELS: Record<string,string> = {todo:"To Do",in_progress:"In Progress",review:"Review",done:"Done"};
const STAGE_COLORS: Record<string,string> = {todo:"bg-gray-100",in_progress:"bg-blue-100",review:"bg-yellow-100",done:"bg-green-100"};

export default function TaskBoard() {
  const qc = useQueryClient();
  const {data:projList}=useQuery({queryKey:["projects"],queryFn:projects});
  const [selProj,setSelProj]=useState<number|undefined>(undefined);
  const {data:taskList}=useQuery({queryKey:["tasks",selProj],queryFn:()=>tasks(selProj)});
  const [form,setForm]=useState({name:"",description:""});
  const [showForm,setShowForm]=useState(false);

  const moveMut=useMutation({mutationFn:({id,stage}:{id:number;stage:string})=>move(id,stage),onSuccess:()=>qc.invalidateQueries({queryKey:["tasks"]})});
  const createMut=useMutation({mutationFn:()=>create({...form,projectId:selProj}),onSuccess:()=>{qc.invalidateQueries({queryKey:["tasks"]});setForm({name:"",description:""});setShowForm(false)}});

  const byStage = new Map<string,any[]>();
  for(const s of STAGES) byStage.set(s,[]);
  taskList?.forEach((t:any)=>{const s=t.stage??"todo";if(byStage.has(s))byStage.get(s)!.push(t)});

  return <div>
    <div className="flex items-center justify-between mb-4">
      <h1 className="text-2xl font-bold">Tasks</h1>
      <div className="flex gap-3">
        <select value={selProj??""} onChange={e=>setSelProj(e.target.value?Number(e.target.value):undefined)} className="border rounded-lg px-3 py-2 text-sm outline-none">
          <option value="">All Projects</option>
          {projList?.map((p:any)=><option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
        <button onClick={()=>setShowForm(!showForm)} className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700">+ Add Task</button>
      </div>
    </div>

    {showForm && <form onSubmit={e=>{e.preventDefault();createMut.mutate()}} className="bg-white rounded-xl shadow-sm border p-4 mb-6 flex gap-3 max-w-xl">
      <input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Task title *" className="flex-1 border rounded px-3 py-2 text-sm outline-none" required/>
      <input value={form.description} onChange={e=>setForm({...form,description:e.target.value})} placeholder="Description" className="flex-1 border rounded px-3 py-2 text-sm outline-none"/>
      <button type="submit" disabled={createMut.isPending} className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 disabled:opacity-50">Add</button>
    </form>}

    <div className="flex gap-4 overflow-x-auto pb-4">
      {STAGES.map(stage => {
        const items = byStage.get(stage)??[];
        return <div key={stage} className="flex-shrink-0 w-64 bg-gray-50 rounded-xl p-3" onDragOver={e=>e.preventDefault()} onDrop={()=>{}}>
          <div className="flex items-center justify-between mb-3"><h3 className="font-semibold text-sm">{STAGE_LABELS[stage]}</h3><span className="text-xs text-gray-400 bg-white px-2 py-0.5 rounded-full">{items.length}</span></div>
          <div className="space-y-2 min-h-16">
            {items.map((t:any)=><div key={t.id} className={`${STAGE_COLORS[stage]} rounded-lg p-3 border`}>
              <p className="font-medium text-sm">{t.name}</p>
              {t.description && <p className="text-xs text-gray-500 mt-1 truncate">{t.description}</p>}
              <div className="flex gap-1 mt-2">
                {stage!=="done"&&<button onClick={()=>moveMut.mutate({id:t.id,stage:STAGES[STAGES.indexOf(stage)+1]})} className="text-xs text-blue-600 hover:text-blue-800">→ {STAGE_LABELS[STAGES[STAGES.indexOf(stage)+1]]}</button>}
              </div>
            </div>)}
            {items.length===0&&<div className="text-xs text-gray-400 text-center py-4 border-2 border-dashed border-gray-200 rounded-lg">Drop tasks here</div>}
          </div>
        </div>;
      })}
    </div>
  </div>;
}
